module.exports = __webpack_public_path__ + "img/kitchen-cuttingboard.c2ae25c8.webp";